<div class="impersonation-status-bar" ng-if="impersonating">
    <div>{{impersonatingText}}</div>
    <button class="end-impersonation-button" ng-click="endImpersonation()">{{'endImpersonation'|translate}}</button>
</div> 